// extracted by mini-css-extract-plugin
export default {"button":"_3Mwz_PuHUDGNrkV7OZmdpH"};